import {
    FormHandlerInside,
    FormHandlerInsideResponseMiddleware,
} from '@root/utils/withForm';
import { FormikHelpers, useFormikContext } from 'formik';
import { MacroServerResponse } from '../Types';

const useMacroMiddleware = <
    FormValues extends {}
>(
    submitHandler: FormHandlerInside<FormValues, FormikHelpers<FormValues>>,
): FormHandlerInside<FormValues> => {
    const { setFieldValue } = useFormikContext();
    return (ctx) => {
        const responseMiddleWare: FormHandlerInsideResponseMiddleware<
        MacroServerResponse
        > = (response) => {
            if (typeof response.paymentid === 'number') {
                setFieldValue('paymentid', response.paymentid);
            } else {
                setFieldValue('paymentid', undefined);
            }
        };
        return submitHandler({
            ...ctx,
            responseMiddleWare,
        });
    };
};

export default useMacroMiddleware;
